export default "__VITE_ASSET__BvkVeEdE__"